import {
  Anchor,
  Button,
  Card,
  Center,
  Divider,
  Stack,
  ThemeIcon,
  Title,
  TypographyStylesProvider,
  Image,
} from "@mantine/core";

import React from "react";
import DocsHighlightCard from "../articlesHelpers/DocsHighlightCard";
import {
  IconArrowBigDownFilled,
  IconFileInvoice,
  IconKey,
  IconPlus,
} from "@tabler/icons-react";
import DocsButton from "../articlesHelpers/DocsButton";
import SimpleImage from "../articlesHelpers/SimpleImage";

export const DEPOSIT_BTC_CONTENT = (
  <TypographyStylesProvider>
    <p>
      Your Rizful Node lightning node can also hold on-chain BTC. You will need
      on-chain BTC to open your own channels. Also, when you close a channel,
      the funds on your side of the channel will "settle" or "revert" to
      on-chain BTC.{" "}
    </p>

    <p>You can deposit BTC with this button:</p>
    <DocsButton
      ariaLabel="deposit btc"
      text="Deposit BTC"
      leftSection={<IconArrowBigDownFilled />}
    />

    <p>You'll then see a screen like this: </p>

    <SimpleImage
      h={400}
      // w={356}

      src="docs_images/deposit-btc-first-screen.png"
    />
    <p>
      As you can see, Rizful Node has specific recommendations for an amount you
      should deposit if you are planning to open a channel.
    </p>
    <p>
      {" "}
      You can deposit any amount you like, but Rizful Node does enforce a
      minimum channel size of 150,000 satoshis. This is for a few reasons:
    </p>
    <ol>
      <li>
        It's a good idea to have a channel that can handle a few payments in the
        same direction without needing to be closed and reopened.
      </li>
      <li>
        {" "}
        For each channel you open, you'll need to pay on-chain transaction fees,
        so it's much better to have one "big" channel instead of many "small"
        channels.
      </li>
      <li> Many node operators enforce a miniumum channel size.</li>
    </ol>

    <p>To make your deposit, use the Make New BTC Address button:</p>

    <SimpleImage h={250} src="docs_images/new-btc-address.png" />

    <p>
      So, what is the difference between new-style and old-style addresses?{" "}
    </p>
    <p>
      Old-style addresses use a pre-2020 format which is less space-efficient on
      the blockchain, and for that reason requires higher transaction fees.{" "}
    </p>

    <p>
      You don't need to think deeply about this question, however: A good
      practice is to first try a new-style address, and only if you find that
      your service or wallet does not support that, then try an old-style
      address.
    </p>

    <p>
      {" "}
      You will find that by clicking on one of the buttons, you'll see both a QR
      Code (good for scanning into a wallet on your phone), and a text string,
      which you can copy to your clipboard:
    </p>

    <SimpleImage h={400} src="docs_images/new-style-address.png" />

    <p>
      {" "}
      And one more thing you need to understand, for safety: Rizful Node nodes
      with zero BTC balance and no open channels will eventually be deleted. Any
      funds sent to an address from a deleted node will be lost forever. Do NOT
      use any BTC address generated on this screen as a long-term "pay to"
      address. If you are expecting any inbound payments to a Rizful Node BTC
      address, please be sure your node has a small positive BTC balance, or at
      least one open channel, so the node does not get deleted!
    </p>
  </TypographyStylesProvider>
);
